import React, { useCallback, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import Paper from 'mrf/view/Paper';
import ScrollBar from 'styles/basic/ScrollBar';
import tw, { styled, theme } from 'twin.macro';

const StyledModalWrapper = styled.div`
    && {
        ${tw`relative flex items-center justify-center h-screen p-4 overflow-hidden bg-black bg-opacity-50`}
    }
`;


const StyledModalContainer = styled.div`
    ${tw`container flex justify-center`}
`;

const StyledModalScroll = styled(ScrollBar)`
    && {
        ${tw`max-h-screen overflow-y-scroll pr-8 pl-2 overflow-x-hidden`}
        width: ${({ width = 'full' }) => theme('width')[width]};
        @media (min-width: ${theme`screens.md`}) {
            width: ${({ md = 'auto' }) => theme('width')[md]};
        }
    }
`;

const CloseButton = styled.button`
    ${tw`absolute top-0 right-0 self-end w-8 h-8 -mt-3 -mr-3 font-bold text-red-700 bg-red-200 rounded-full`}
`;

const Modal = ({
    modal,
    close,
    children,
    width,
    color,
    direction = 'col'
}) => {
    const handleOverlayClicked = (e) => {
        if (e.target.id === 'modal-wrapper') {
            e.stopPropagation();
            close();
        }
    };

    if (!modal) {
        return false;
    }

    return ReactDOM.createPortal(
        <>
            <div className='fixed top-0 left-0 z-50 w-full min-h-screen'>
                <StyledModalWrapper
                    aria-modal
                    aria-hidden
                    role='dialog'
                    id='modal-wrapper'
                    onMouseDown={handleOverlayClicked}
                >
                    <StyledModalContainer>
                        <StyledModalScroll md={width}>
                            <Paper
                                color={color}
                                direction={direction}
                                className='relative m-4'
                            >
                                <CloseButton onClick={close}>&times;</CloseButton>
                                {children}
                            </Paper>

                        </StyledModalScroll>
                    </StyledModalContainer>
                </StyledModalWrapper>
                
            </div>
        </>,
        document.body
    );
};

export const useModal = () => {
    const [modal, setModal] = useState(false);

    const open = useCallback(
        e => {
            e?.preventDefault?.(); // eslint-disable-line
            setModal(true);
        },
        [setModal]
    );

    const close = useCallback(
        e => {
            e?.preventDefault?.(); // eslint-disable-line
            e?.stopPropagation?.(); // eslint-disable-line
            setModal(false);
        },
        [setModal]
    );

    const toggle = useCallback(
        e => {
            e?.preventDefault?.(); // eslint-disable-line
            setModal(!modal);
        },
        [modal, setModal]
    );

    // const handleKeyUp = e => {
    //     e.stopPropagation();
    //     if (e.keyCode !== 27) return;
    //     if (document.activeElement && [ 'INPUT', 'SELECT' ].includes(document.activeElement.tagName)) return;

    //     close();

    //     if (options?.onEscapeKeyUp) {
    //         options.onEscapeKeyUp();
    //     }
    // }

    //() => {
    //     if (modal) {
    //         document.addEventListener('keyup', handleKeyUp);
    //         return () => document.removeEventListener('keyup', handleKeyUp);
    //     }
    // }, [ modal ]); // eslint-disable-line

    return useMemo(
        () => ({ modal, open, close, toggle }),
        [modal, open, close, toggle]
    );
};

Modal.useModal = useModal;

export default Modal;
